import React from 'react';
import PropTypes from 'prop-types';

import './markers.scss';

const Markers = ({openWindow}) => {

  return (
          <ul className="markers" >
            <li> 
              <button onClick={(e) => openWindow(e,'aboutOpen')}>Sobre el proyecto</button>
            </li>
            <li> 
              <button onClick={(e)=>openWindow(e,'tutoOpen')}>Tutorial web</button>
            </li>
          </ul>
  );
}

Markers.propTypes = {
  openWindow: PropTypes.func.isRequired,
}

Markers.defaultProps = {
};

export default Markers;